module.exports = __webpack_public_path__ + "img/Dantam Hair 18.9c11b969.jpg";